var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadAppVaSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M62 4H30C24.48 4 20 8.48 20 14V82C20 87.52 24.48 92 30 92H62C67.52 92 72 87.52 72 82V14C72 8.48 67.52 4 62 4ZM46 88C42.68 88 40 85.32 40 82C40 78.68 42.68 76 46 76C49.32 76 52 78.68 52 82C52 85.32 49.32 88 46 88ZM64 72H28V16H64V72Z",
  fill: "#407A8C"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadAppVaSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download-app-va-sensia.073004e139c16b20c62c30e1f20506bc.svg";